// Reducer extracted from MyCalendarModule.js

import moment from "moment-timezone";
import update from "immutability-helper";
import { MY_CALENDAR_CONSTANTS } from "MyCalendar/constants/stringConstants";
import { getISODate, getTodaysDate } from "Utils/DateTimeHelpers";
import React from "react";
import {
  UPDATE_STATE,
  UPDATE_DAILY_VIEW_STATE,
  UPDATE_VIEW_ONLY_TAGS_STATE,
  UPDATE_FULL_SCREEN_VIEW_DATA,
  SET_SELECTED_SYNC_CALENDAR,
  INITIAL_CONTENT_TYPES,
  UPDATE_CALENDAR_SYNC_MODAL_STATE,
  MICROSOFT_CALENDAR,
  VIEW_FILTER_MAPPING,
  UPDATE_EVENT_MODALV2_STATE,
  INITIAL_EVENT_MODALV2_STATE,
  RESET_EVENT_MODALV2_STATE,
  UPDATE_WEEKLY_REPEAT_EVENT_SETTINGS,
  UPDATE_DAILY_REPEAT_EVENT_SETTINGS,
  UPDATE_MONTHLY_SET_POSITIONS_REPEAT_EVENT_SETTINGS,
  UPDATE_MONTHLY_DAY_POSITIONS_REPEAT_EVENT_SETTINGS,
} from "./MyCalendarConstants";

// Initial State
const initialState = {
  dailyView: {
    week: moment().isoWeek(),
    visibleDays: [0, 1, 2, 3, 4, 5, 6],
    selectedDate: moment().startOf("day").toDate().toISOString(),
    calendarIds: [],
    folderIds: [],
    contentTypes: INITIAL_CONTENT_TYPES,
    calendarView: VIEW_FILTER_MAPPING.DAILY,
    agendaView: {
      currentDate: moment(),
      selectedDate: moment(),
    },
  },
  fullscreenView: {
    week: moment().isoWeek(),
    selectedDate: getISODate({ date: getTodaysDate() }),
    visibleDays: [0, 1, 2, 3, 4, 5, 6],
    calendarIds: [],
    folderIds: [],
    notUserCourseIds: [],
  },
  monthlyView: {
    currentMonth: moment(),
  },
  listView: {
    currentStartDate: moment(),
  },
  agendaView: {
    currentDate: moment(),
  },
  calendarParentColorMap: {},
  calendarView: MY_CALENDAR_CONSTANTS.WEEK,
  assessmentTypes: [],
  schoolCalendarTagIds: [],
  mypTags: [],
  dpTags: [],
  contentTypes: INITIAL_CONTENT_TYPES,
  schoolCalendarTags: [],
  isDefaultViewSet: false,
  projectGroups: [],
  yearGroupId: null,
  projectGroupId: null,
  viewOnlyData: {
    schoolCalendarTagIds: [],
    assessmentTypes: [],
    mypTags: [],
    dpTags: [],
  },
  selectedViewOnlyTags: [],
  viewOnlyTagsList: [],
  courseProjectGroups: [],
  courseId: null,
  deadlinesCount: -1,
  isCalendarSyncModalOpen: false,
  selectedSyncCalendarLabel: MICROSOFT_CALENDAR,
  isStudentProfileCalendarView: false,
  studentProfileId: null,
  eventModal: INITIAL_EVENT_MODALV2_STATE,
  shouldNotifyParticipants: false,

  rnpRoleContextDetail: [],

  // selected school details for big org switcher
  selectedSchool: {
    selectedSchoolId: null,
    selectedSchoolType: null,
  },
};

// Reducer Handlers
const REDUCER_HANDLERS = {
  [UPDATE_STATE]: (state, action) => {
    const params = action.data;
    Object.keys(params).map(key => {
      state = update(state, {
        [key]: { $set: params[key] },
      });
    });
    return state;
  },
  [UPDATE_DAILY_VIEW_STATE]: (state, action) => {
    const params = action.data;
    return update(state, {
      dailyView: { $set: { ...state.dailyView, ...params } },
    });
  },
  [UPDATE_VIEW_ONLY_TAGS_STATE]: (state, action) => {
    const params = action.data;
    return update(state, {
      viewOnlyData: { $set: { ...state.viewOnlyData, ...params } },
    });
  },
  [UPDATE_FULL_SCREEN_VIEW_DATA]: (state, action) => {
    const params = action.data;
    return update(state, {
      fullscreenView: { $set: { ...state.fullscreenView, ...params } },
    });
  },
  [UPDATE_CALENDAR_SYNC_MODAL_STATE]: (state, action) => {
    const params = action.data;
    return update(state, {
      isCalendarSyncModalOpen: { $set: params },
    });
  },
  [SET_SELECTED_SYNC_CALENDAR]: (state, action) => {
    const params = action.data;
    return update(state, {
      selectedSyncCalendarLabel: { $set: params },
    });
  },
  [UPDATE_EVENT_MODALV2_STATE]: (state, action) => {
    const params = action.data;
    return update(state, {
      eventModal: { $set: { ...state.eventModal, ...params } },
    });
  },
  [RESET_EVENT_MODALV2_STATE]: state => {
    return update(state, {
      eventModal: { $set: INITIAL_EVENT_MODALV2_STATE },
    });
  },
  [UPDATE_WEEKLY_REPEAT_EVENT_SETTINGS]: (state, action) => {
    const params = action.data;
    return update(state, {
      eventModal: {
        repeatEventSettings: {
          $set: {
            ...state.eventModal.repeatEventSettings,
            weekDays: params,
            monthDays: [],
            setPositions: [],
          },
        },
      },
    });
  },
  [UPDATE_MONTHLY_DAY_POSITIONS_REPEAT_EVENT_SETTINGS]: (state, action) => {
    const params = action.data;
    return update(state, {
      eventModal: {
        repeatEventSettings: {
          $set: {
            ...state.eventModal.repeatEventSettings,
            monthDays: params,
            weekDays: [],
            setPositions: [],
          },
        },
      },
    });
  },
  [UPDATE_MONTHLY_SET_POSITIONS_REPEAT_EVENT_SETTINGS]: (state, action) => {
    const params = action.data;
    return update(state, {
      eventModal: {
        repeatEventSettings: {
          $set: {
            ...state.eventModal.repeatEventSettings,
            setPositions: params,
            weekDays: [],
            monthDays: [],
          },
        },
      },
    });
  },
  [UPDATE_DAILY_REPEAT_EVENT_SETTINGS]: (state, action) => {
    return update(state, {
      eventModal: {
        repeatEventSettings: {
          $set: {
            ...state.eventModal.repeatEventSettings,
            weekDays: [],
            monthDays: [],
            setPositions: [],
          },
        },
      },
    });
  },
};

// Reducer
export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

// Auto-generated exports
export { initialState, REDUCER_HANDLERS };
